import { defineMessages } from 'react-intl';

const messages: {
	admin: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	analytics: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	assets: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	chat: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	goals: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	home: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	projects: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	rovo: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	search: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	studio: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	teams: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	admin: {
		id: 'navigation.ribbon.navigation-ribbon.product.admin.label',
		defaultMessage: 'Admin',
		description: 'The text of a link redirecting the user to the Admin app',
	},
	analytics: {
		id: 'navigation.ribbon.navigation-ribbon.product.analytics.label',
		defaultMessage: 'Analytics',
		description: 'The text of a link redirecting the user to the Analytics app',
	},
	assets: {
		id: 'navigation.ribbon.navigation-ribbon.product.assets.label',
		defaultMessage: 'Assets',
		description: 'The text of a link redirecting the user to the Assets app',
	},
	chat: {
		id: 'navigation.ribbon.navigation-ribbon.product.chat.label',
		defaultMessage: 'Chat',
		description: 'The text of a link redirecting the user to the Chat app',
	},
	goals: {
		id: 'navigation.ribbon.navigation-ribbon.product.goals.label',
		defaultMessage: 'Goals',
		description: 'The text of a link redirecting the user to the Goals app',
	},
	home: {
		id: 'navigation.ribbon.navigation-ribbon.product.home.label',
		defaultMessage: 'Home',
		description: 'The text of a link redirecting the user to the Home app',
	},
	projects: {
		id: 'navigation.ribbon.navigation-ribbon.product.projects.label',
		defaultMessage: 'Projects',
		description: 'The text of a link redirecting the user to the Projects app',
	},
	rovo: {
		id: 'navigation.ribbon.navigation-ribbon.product.rovo.label',
		defaultMessage: 'Rovo',
		description: 'The text of a link redirecting the user to the Rovo app',
	},
	search: {
		id: 'navigation.ribbon.navigation-ribbon.product.search.label',
		defaultMessage: 'Search',
		description: 'The text of a link redirecting the user to the Search app',
	},
	studio: {
		id: 'navigation.ribbon.navigation-ribbon.product.studio.label',
		defaultMessage: 'Studio',
		description: 'The text of a link redirecting the user to the Studio app',
	},
	teams: {
		id: 'navigation.ribbon.navigation-ribbon.product.teams.label',
		defaultMessage: 'Teams',
		description: 'The text of a link redirecting the user to the Teams app',
	},
});
export default messages;
